import { v4 as uuid } from 'uuid'
import { getCookie, setCookie } from 'cookies-next'

import { DEVICE_ID_STORAGE_KEY } from 'configs/deviceId'

const COOKIE_MAX_AGE = 60 * 60 * 24 * 365 // 1 year

export const getDeviceId = (ctx?: { req: any; res: any } | null): string => {
  const { req, res } = ctx ?? {}

  // Server-side: prefer device-id header sent by the Android app
  if (req) {
    const appDeviceId: string = req.headers['device-id'] || ''
    if (appDeviceId) {
      setCookie(DEVICE_ID_STORAGE_KEY, appDeviceId, {
        req,
        res,
        maxAge: COOKIE_MAX_AGE,
      })
      return appDeviceId
    }
  }

  // Server-side or client-side: return existing cookie value
  const deviceIdFromCookie = getCookie(DEVICE_ID_STORAGE_KEY, { req, res })
  if (deviceIdFromCookie) {
    return deviceIdFromCookie as string
  }

  // Generate, persist, and return a new device ID
  const generatedDeviceId = uuid()
  setCookie(DEVICE_ID_STORAGE_KEY, generatedDeviceId, {
    req,
    res,
    maxAge: COOKIE_MAX_AGE,
  })
  return generatedDeviceId
}
